// extracted by mini-css-extract-plugin
export default {"title":"CallStatusChart_title__A3FE6"};